// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__ORAy0","icon":"ThemeToggle_icon__Z1THH"};